import { axiosPrivate } from '../../api/axios';
import { useState } from 'react';
import { DateTime, Settings } from 'luxon'
import { getAdjCourt } from '../../utils/getAdjCourts'
Settings.defaultLocale = 'el'

Date.createFromMysql = function (mysql_string) {
  var t, result = null;

  if (typeof mysql_string === 'string') {
    t = mysql_string.split(/[- :]/);

    //when t[3], t[4] and t[5] are missing they defaults to zero
    result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
  }

  return result;
}
function formatDate(date) {
  const newDate = new Date(Date.createFromMysql(date));

  const formatedDate = DateTime.fromISO(newDate.toISOString()).plus({ hours: 3 }).toFormat('ff')
  return formatedDate
}


const DikasimosCard = ({ singleUpdate }) => {
  function UpdateCardTranform(singleUpdate) {
    if (singleUpdate.eak) {
      return (<article className='case_card'>
        {/* <div key={`ed${singleUpdate.id}`} className="edit_case"><p ><span onClick={handleDelete} data-key={singleUpdate.id}>✏️</span></p></div> */}
        <h3 data-case='astiki'>Αστική</h3>
        {singleUpdate?.note?.length > 0 && <h4><em>Σημείωση: </em>{singleUpdate?.note}</h4 >}
        <h4><em>ΓΑΚ:</em> {singleUpdate?.gak}/{singleUpdate?.year}</h4>
        <h4><em>Δικαστήριο:</em> {singleUpdate?.court}</h4>

        {singleUpdate?.dikasimos?.length > 2 && <h4><em>Δικάσιμος:</em> {singleUpdate?.dikasimos}</h4>}




      </article >)
    }
    if (!singleUpdate.eak) {
      return (<article className='case_card'>

        {/* <div key={`ed${singleUpdate.id}`} className="edit_case"><p ><span onClick={handleDelete} data-key={singleUpdate.id}>✏️</span></p></div> */}
        <h3 data-case='dioikitiki'>Διοικητική</h3>
        {singleUpdate?.note?.length > 0 && <h4><em>Σημείωση: </em>{singleUpdate?.note}</h4 >}

        <h4><em>Αρ.Κατ:</em> {singleUpdate?.arkat}</h4>
        <h4><em>Δικαστήριο:</em> {getAdjCourt(singleUpdate?.court)}</h4>


        {singleUpdate?.dikasimos?.length > 2 && <h4><em>Δικάσιμος:</em> {singleUpdate?.dikasimos}</h4>}




      </article >)
    }
  }

  return (
    UpdateCardTranform(singleUpdate)
  )
}

export default DikasimosCard